<app-frame [overlay]="false" [title]="title" (neadClose)="closeVisitForm()" autocomplete="off">
	<div>
		{{errorMessage}}
	</div>
	<app-form-actions-content>
		<form-button (clickOnButton)="goToPerson()">Go to Person</form-button>
		<form-button (clickOnButton)="closeVisitForm()" buttonType="warning">Close</form-button>
	</app-form-actions-content>
</app-frame>
